/* NISEO Skin — store theme JS.
   Mobile menu, cart/waitlist drawers, AJAX cart, qty steppers, scroll reveals. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var qs = function (s, el) { return (el || document).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  function lockScroll(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }

  var routeSource = document.body || document.documentElement;
  var cartJsonUrl = routeSource.getAttribute('data-cart-json-url') || '/cart.js';
  var cartAddJsonUrl = routeSource.getAttribute('data-cart-add-json-url') || '/cart/add.js';
  var cartChangeJsonUrl = routeSource.getAttribute('data-cart-change-json-url') || '/cart/change.js';
  var activeOverlay = null;

  function focusableElements(el) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (node) { return node.offsetWidth > 0 || node.offsetHeight > 0 || node === document.activeElement; });
  }

  function setTriggerState(id, expanded) {
    qsa('[aria-controls="' + id + '"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function closeOverlay(el, restoreFocus) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    setTriggerState(el.id, false);
    if (activeOverlay === el) activeOverlay = null;
    var trigger = el._niseoTrigger;
    el._niseoTrigger = null;
    if (restoreFocus !== false && trigger && document.contains(trigger)) trigger.focus();
  }

  function closeAll(restoreFocus) {
    qsa('.niseo-drawer-root.is-open, .niseo-mobile-menu.is-open').forEach(function (el) {
      closeOverlay(el, restoreFocus);
    });
    lockScroll(false);
  }

  function openOverlay(el, trigger) {
    if (!el) return;
    closeAll(false);
    el._niseoTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    setTriggerState(el.id, true);
    activeOverlay = el;
    lockScroll(true);
    window.requestAnimationFrame(function () {
      var initial = qs('[data-overlay-initial-focus]', el) || focusableElements(el)[0] || el;
      initial.focus();
    });
  }

  qsa('[data-open-cart]').forEach(function (el) { el.setAttribute('aria-controls', 'NiseoCartDrawer'); el.setAttribute('aria-expanded', 'false'); });
  qsa('[data-open-waitlist]').forEach(function (el) { el.setAttribute('aria-controls', 'NiseoWaitlistDrawer'); el.setAttribute('aria-expanded', 'false'); });
  qsa('[data-menu-open]').forEach(function (el) { el.setAttribute('aria-controls', 'NiseoMobileMenu'); el.setAttribute('aria-expanded', 'false'); });
  qsa('.niseo-drawer-root, .niseo-mobile-menu').forEach(function (el) { el.setAttribute('aria-hidden', 'true'); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart], [data-open-waitlist], [data-menu-open], [data-drawer-close], [data-menu-close], .niseo-scrim');
    if (!t) return;
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); refreshCart(); openOverlay(qs('#NiseoCartDrawer'), t); }
    else if (t.hasAttribute('data-open-waitlist')) { e.preventDefault(); openOverlay(qs('#NiseoWaitlistDrawer'), t); }
    else if (t.hasAttribute('data-menu-open')) { e.preventDefault(); openOverlay(qs('#NiseoMobileMenu'), t); }
    else { e.preventDefault(); closeAll(true); }
  });

  document.addEventListener('keydown', function (e) {
    if (!activeOverlay) return;
    if (!activeOverlay.classList.contains('is-open')) { activeOverlay = null; return; }
    if (e.key === 'Escape') { e.preventDefault(); closeAll(true); return; }
    if (e.key !== 'Tab') return;
    var items = focusableElements(activeOverlay);
    if (!items.length) { e.preventDefault(); activeOverlay.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function money(cents) {
    var v = cents / 100;
    var s = v.toFixed(2).replace(/\.00$/, '');
    return '\u20AC' + s;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var drawer = qs('#NiseoCartDrawer');
  var strings = drawer ? {
    remove: drawer.getAttribute('data-t-remove') || 'Remove',
    dec: drawer.getAttribute('data-t-decrease') || 'Decrease quantity',
    inc: drawer.getAttribute('data-t-increase') || 'Increase quantity'
  } : {};
  var setVariantId = drawer ? drawer.getAttribute('data-set-variant') : null;

  function renderCart(cart) {
    if (!drawer) return;
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var empty = qs('[data-cart-empty]', drawer);
    var full = qs('[data-cart-full]', drawer);
    if (empty) empty.style.display = cart.item_count === 0 ? '' : 'none';
    if (full) full.style.display = cart.item_count === 0 ? 'none' : '';
    var sub = qs('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = money(cart.items_subtotal_price);

    var wrap = qs('[data-cart-lines]', drawer);
    if (wrap) {
      wrap.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img src="' + escapeHtml(item.image) + '&width=160" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="160" height="200">'
          : '';
        return '<div class="niseo-cart-line">' +
          '<div class="niseo-cart-line-img">' + img + '</div>' +
          '<div class="niseo-cart-line-info">' +
            '<div class="niseo-cart-line-top"><span>' + escapeHtml(item.product_title) + '</span><span>' + money(item.final_line_price) + '</span></div>' +
            '<div class="niseo-caption">' + (item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '') + '</div>' +
            '<div class="niseo-cart-line-ctrl">' +
              '<div class="niseo-qty">' +
                '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + strings.dec + '">\u2212</button>' +
                '<span style="min-width:24px;text-align:center;font-size:14px">' + item.quantity + '</span>' +
                '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + strings.inc + '">+</button>' +
              '</div>' +
              '<button type="button" class="niseo-cart-remove" data-line="' + (i + 1) + '" data-qty="0">' + strings.remove + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    var upsell = qs('[data-cart-upsell]', drawer);
    if (upsell && setVariantId) {
      var hasSet = cart.items.some(function (it) { return String(it.variant_id) === String(setVariantId); });
      upsell.style.display = (cart.item_count > 0 && !hasSet) ? '' : 'none';
    }
  }

  function setCartBusy(busy) { if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false'); }

  function refreshCart() {
    setCartBusy(true);
    fetch(cartJsonUrl).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}).finally(function () { setCartBusy(false); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line][data-qty]');
    if (!btn) return;
    e.preventDefault();
    fetch(cartChangeJsonUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(btn.getAttribute('data-line')), quantity: Number(btn.getAttribute('data-qty')) })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(cartAddJsonUrl, { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { refreshCart(); openOverlay(qs('#NiseoCartDrawer')); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-set]');
    if (!b || !setVariantId) return;
    e.preventDefault();
    fetch(cartAddJsonUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(setVariantId), quantity: 1 }] })
    }).then(function () { refreshCart(); openOverlay(qs('#NiseoCartDrawer')); }).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    e.preventDefault();
    var box = (minus || plus).closest('.niseo-qty');
    var input = box && box.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, Math.min(9, v + (plus ? 1 : -1)));
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    qsa('[data-reveal]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.88) el.classList.add('is-visible');
      else io.observe(el);
    });
  } else {
    qsa('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  if (drawer) refreshCart();
})();
